/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import './PendingEmail.styles.scss';

import { TextLink } from '../../../../components/TextLink';
import DateUtil from '../../../../../utilities/DateUtil';

interface Props {
  resend(callback): void;
  cancel(): void;
  email: string;
  isSelf: boolean;
  expirationDate: string;
}

const PendingEmail: React.FC<Props> = (props) => {
  const { resend, cancel, isSelf, email, expirationDate } = props;
  const [isResending, setIsResending] = React.useState(false);

  const resendPhrase = isResending ? 'profileAccess.resendingOwnerInvite.message.text' : 'profileAccess.resendOwnerInvite.button.label';

  const resendEnail = () => {
    if (isResending) { return; }

    setIsResending(true);

    resend(() => {
      setIsResending(false);
    });
  };

  const formattedExpiration = DateUtil.formattedMediumDate(expirationDate, 'P1D');

  return (
    <div className="cmp-pending-email">
      <div className="email">
        {email}
      </div>

      <div className="access">
        {
          isSelf && (
            <>
              <FormattedMessage id="access.userList.self.label" />{' – '}
            </>
          )
        }
      </div>
      <div className="font-footnote font-color-gsDark" style={{ marginTop: 4 }}>
        <FormattedMessage id="access.userList.fullAccess.label" />
      </div>
      <div className="font-caption-1 font-color-gsMedDark" style={{ marginTop: 4 }}>
        <FormattedMessage id="access.inviteExpiresDate.message" values={{ string1: formattedExpiration }} />
      </div>
      <div className="controls">
        <TextLink className="font-footnote font-color-profile" onClick={resendEnail}>
          <FormattedMessage id={resendPhrase} />
        </TextLink>
        <TextLink className="font-footnote font-color-profile" onClick={cancel}>
          <FormattedMessage id="profileAccess.cancelOwnerInvite.button.label" />
        </TextLink>
      </div>
    </div>
  );
};

export default PendingEmail;
